import { render } from "./AuthWizard.vue?vue&type=template&id=1303b4df&scoped=true"
import script from "./AuthWizard.vue?vue&type=script&lang=js"
export * from "./AuthWizard.vue?vue&type=script&lang=js"

import "./AuthWizard.vue?vue&type=style&index=0&id=1303b4df&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1303b4df"]])

export default __exports__